import { useState, useEffect } from 'react';
import {
    addCart,
    updateCart,
    getCartsById,
    removeCartsById,
    getCartsByIdUser
} from '../services/CartService';

export const useCarts = () => {

    const [cart, setCart] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchProductCartsById = async (id) => {
        try {
            setLoading(true);
            const response = await getCartsById(id);
            setCart(response.data);
            setLoading(false);
            return response.data
        } catch (err) {
            setError('Failed to fetch products');
        }
    };

    const fetchCartsByIdUser= async () => {
        try {
            setLoading(true);
            const response = await getCartsByIdUser();
            setCart(response.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch products');
        }
    };

    const addProductCart = async (product) => {
        try {
            const response = await addCart(product);
            setCart([...cart, response.data]);
            setLoading(false);
        } catch {
            setError('Failed to add product');
        }
    };

    const editProductCart = async (id, updatedProduct) => {
        try {
            const response = await updateCart(id, updatedProduct);
            setCart(cart.map(p => (p.id === id ? response.data : p)));
            setLoading(false);
        } catch {
            setError('Failed to update product');
        }
    };

    const removeCart = async (id) => {
        try {
            await removeCartsById(id);
            setCart(cart.filter(p => p.id !== id));
        } catch {
            setError('Failed to delete product');
        }
    };
    
    useEffect(() => {
        fetchCartsByIdUser()
    }, []);
    
    return {
        loading,
        error,
        cart,
        editProductCart,
        fetchProductCartsById,
        fetchCartsByIdUser,
        addProductCart,
        removeCart
    };

};